<template>
  <!-- screen for sending email for assistance -->
  <div>
    <nav-bar></nav-bar>

    <div class="container contact" style="min-height: 100vh">
      <div class="row">
        <div class="col-md-6 class-mobile"></div>
        <div class="col-md-6 col-md-6-style-left">
          <p class="page-user">Atendimento</p>
          <form class="contact-form" @submit.prevent="sendRequestCallCenter">
            <div class="form-group col-sm-10">
              <h5 style="color: rgb(100, 95, 95)">
                Precisa de ajuda? Fale com a gente!
              </h5>
              <p style="color: rgb(100, 95, 95)">
                <em class="fa fa-envelope"></em> &nbsp;<span
                  style="color: rgb(100, 95, 95)"
                >
                  {{ this.groupEmail }}</span
                >
                <span v-if="groupOptionalEmail">
                  ou
                  <span style="color: rgb(100, 95, 95)">
                    {{ this.groupOptionalEmail }}
                  </span>
                </span>
              </p>
              <p style="color: rgb(100, 95, 95)">
                <em class="fa fa-phone"></em> &nbsp;
                <span style="color: rgb(100, 95, 95)">
                  {{ this.groupPhone }}</span
                >
                <span v-if="groupOptionalPhone">
                  ou
                  <span style="color: rgb(100, 95, 95)">
                    {{ this.groupOptionalPhone }}
                  </span>
                </span>
              </p>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2"> Nome</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="nameCallCenter"
                  v-model="userName"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-sm" for="email">E-mail</label>
              <div class="col-sm-8">
                <input
                  type="email"
                  class="form-control"
                  v-bind:class="{ 'is-invalid': errors.email }"
                  id="emailCallCenter"
                  placeholder="email@email.com"
                  v-model="userEmail"
                  disabled
                />
                <span v-if="errors.email" class="error">
                  <ul>
                    <li v-for="msg in errors.email">{{ msg }}</li>
                  </ul>
                </span>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-sm-2" for="tel"> Telefone</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="{ 'is-invalid': errors.phone }"
                  id="celCallCenter"
                  placeholder="Digite seu contato de telefone"
                  v-mask="['55 (##)####-####', '55 (##)#####-####']"
                  v-model="userPhone"
                />
                <span v-if="errors.phone" class="error">
                  <ul>
                    <li v-for="msg in errors.phone">{{ msg }}</li>
                  </ul>
                </span>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2"> Empresa</label>
              <div class="col-sm-8">
                <select class="select-class" v-model="selectPayers">
                  <option v-if="payers.length > 1" value="selecione">
                    Selecione
                  </option>
                  <option
                    v-for="(payer, index) in payers"
                    :key="payer.sac_id"
                    :value="payer.sac_id"
                  >
                    {{ payer.sac_inscricao | formatCPFCNPJ }} -
                    {{ payer.sac_razao_social_nome }}
                  </option>
                </select>
                <span v-if="errors.payer_id" class="error">
                  <ul>
                    <li v-for="msg in errors.payer_id">{{ msg }}</li>
                  </ul>
                </span>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2" for="comment"
                >Mensagem</label
              >
              <div class="col-sm-12">
                <textarea
                  class="form-control"
                  rows="5"
                  id="textAreaCallCenter"
                  v-model="userMessage"
                  maxlength="2000"
                ></textarea>
                <div class="length-caracteres">
                  <span> {{ userMessage.length }}/2000</span>
                </div>
                <span v-if="errors.description" class="error">
                  <ul>
                    <li v-for="msg in errors.description">{{ msg }}</li>
                  </ul>
                </span>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-8">
                <button
                  type="submit"
                  id="sendButtonCallCenter"
                  class="btn btn-default access"
                >
                  Enviar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-6 col-md-6-style-right">
          <img
            style="width: 100%; margin-top: 150px; margin-bottom: 150px"
            :src="'static/img/undraw-chat.png'"
            alt=""
          />
        </div>
      </div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import NavBar from "../../../common/components/NavBar";
import FooterNav from "../../../common/components/FooterNav";
import Vue from "vue";
import axios from "axios";

export default {
  components: { NavBar, FooterNav },
  name: "CallCenter",
  data() {
    return {
      groupPhone: "",
      groupOptionalPhone: "",
      groupEmail: "",
      groupOptionalEmail: "",
      userName: "",
      userEmail: "",
      userPhone: "",
      payers: [],
      userMessage: "",
      selectPayers: "",
      errors: [],
    };
  },
  mounted() {
    this.$store.state.navBarActive = "";

    axios.get(`${process.env.API_PBM}/helpDesk/contact`).then((response) => {
      this.groupPhone = response.data.data.grp_phone;
      this.groupOptionalPhone = response.data.data.grp_optional_phone;
      this.groupEmail = response.data.data.grp_email;
      this.groupOptionalEmail = response.data.data.grp_optional_email;
    });

    axios.post(`${process.env.API_PBM}/auth/me`).then((response) => {
      this.userName = response.data.data.usu_nome;
      this.userEmail = response.data.data.usu_email;
      this.userPhone = response.data.data.usu_celular;
    });
    axios.get(`${process.env.API_PBM}/helpDesk/payerList`).then((response) => {
      this.payers = response.data.data;
      if (this.payers.length > 1) {
        this.selectPayers = "selecione";
        return;
      }
      this.selectPayers = this.payers[0]["sac_id"];
    });
  },

  methods: {
    sendRequestCallCenter: function () {
      let data = {
        payer_id: this.selectPayers,
        description: this.userMessage,
        email: this.userEmail,
        phone: this.userPhone,
      };
      axios
        .post(`${process.env.API_PBM}/helpDesk`, this.$qs.stringify(data))
        .then(() => {
          Vue.$toast.success("Mensagem enviada com sucesso!", {
            position: "top-right",
            duration: 3000,
          });
          this.userMessage = "";
          this.selectPayers = "selecione";
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.errors = [];
            this.errors = error.response.data.message;
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
  border: 1px solid rgb(100, 95, 95);
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  margin-left: -25px;
}

.contact {
  padding: 4%;
}

.row {
  padding-top: 30px;
}
.form-control {
  font-size: 14px;
  color: grey;
  border: 1px solid rgb(100, 95, 95);
}
.contact-info h2 {
  margin-bottom: 10%;
}
.col-md-6-style-right {
  background: #fff;
  padding: 3%;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}
.col-md-6-style-left {
  background: #fff;
  padding: 3%;

  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.contact-form label {
  font-weight: 600;
}
.page-user {
  font-size: 18px;
  margin-top: -5px;
}

label {
  font-size: 16px;
  color: rgb(100, 95, 95);
}
.form-group input,
textarea {
  background-color: #fff;
  margin-bottom: 10px;
  margin-top: -8px;
}

.select-class {
  color: grey;
  border: 1px solid rgb(100, 95, 95);
  width: 100%;
  background-color: #fff;
  line-height: 177px;
  height: 40px;
  font-size: 13px;
  border-radius: 6px;
  margin-top: -8px;
}
form {
  background-color: #ebe7e7;
  padding: 10px;
}

.access {
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
}
.contact-form button:focus {
  box-shadow: none;
}

.length-caracteres {
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
}

@media only screen and (max-width: 500px) {
  .class-mobile {
    display: block !important;
  }
  .col-md-6-style-right {
    display: none !important;
  }
  .page-user {
    text-align: center;
  }

  h5 {
    font-size: 17px;
  }
}

.class-mobile {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/components/callcenter/CallCenter.vue